import React from "react";

const ListBlock = ({ block }) => {
    const items = block.items || [];

    const ListTag =
        block.ordered
            ? "ol"
            : "ul";

    return (
        <ListTag
            style={{
                margin: "16px 0",
                paddingLeft: 30,
            }}
        >
            {items.map((item, index) => (
                <li key={index}>
                    {item}
                </li>
            ))}
        </ListTag>
    );
};

export default ListBlock;